// extracted by mini-css-extract-plugin
module.exports = {"modal":"vendors_modal__30bRe","button":"vendors_button__1p_KL","heading":"vendors_heading__16zdQ","table":"vendors_table__Yav7Q"};